import { warehouseModel } from '@entities/warehouse';
import { createEvent, createStore, sample } from '@lib/state-engine';
import { IWarehouse } from '@@/warehouses/ts';

export const remove = createEvent<IWarehouse['id']>();
export const submit = createEvent();
export const closeSubmit = createEvent();
export const closeSuccess = createEvent();
export const closeError = createEvent();
export const closeCannotRemove = createEvent();

export const $warehouse = warehouseModel.$warehouseInfo;
export const $pending = warehouseModel.$isRemovingWarehouse;
export const $modalVisible = createStore(false).reset([
  closeSubmit,
  warehouseModel.removeWarehouseByIdSuccess,
  warehouseModel.removeWarehouseByIdError,
]);
export const $errorModalVisible = createStore(false).reset(closeError);
export const $successModalVisible = createStore(false).reset(closeSuccess);
export const $cannotRemoveVisible = createStore(false).reset(closeCannotRemove);

/**
 * При удалении проверяем, что все хранилища склада пустые
 */

sample({
  clock: remove,
  source: $warehouse,
  filter: (wh) => Number(wh?.filledBags) === 0,
  fn: () => true,
  target: $modalVisible,
});

sample({
  clock: remove,
  source: $warehouse,
  filter: (wh) => Number(wh?.filledBags) > 0,
  fn: () => true,
  target: $cannotRemoveVisible,
});

sample({
  clock: submit,
  source: $warehouse,
  fn: (wh) => Number(wh?.id),
  target: warehouseModel.removeWarehouseById,
});

sample({
  clock: warehouseModel.removeWarehouseByIdSuccess,
  fn: () => true,
  target: $successModalVisible,
});

sample({
  clock: warehouseModel.removeWarehouseByIdError,
  fn: () => true,
  target: $errorModalVisible,
});
